import { render, staticRenderFns } from "./cell-user-role.vue?vue&type=template&id=40f6f7ca"
import script from "./cell-user-role.ts?vue&type=script&lang=ts&external"
export * from "./cell-user-role.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports